import styled from 'styled-components';

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 60px;

    > button {
        width: 250px;
        height: 45px;
        margin: 0 10px;
    }
`;
